export const informesActividades = [
    {
        "imagen" : "http://dif.hidalgo.gob.mx/informes/2022-2028/1er_Informe_2023.jpeg",
        "informe" : "1er. Informe",
        "fecha" : "25 de Octubre de 2023",
        "lugar" : "Auditorio Gota de Plata",
        "url" : "http://dif.hidalgo.gob.mx/InformeActividades/1erInforme/",
        "anio" : "2023",
        "recursos" : [
            {
                "recurso" : "Video",
                "url" : "http://dif.hidalgo.gob.mx/informes/2022-2028/1er_INFORME_2023.mp4"
            }
        ]
    },
    {
        "imagen" : "http://dif.hidalgo.gob.mx/informes/2022-2028/2do_informe_2024.png",
        "informe" : "2do. Informe",
        "fecha" : "23 de Octubre de 2024",
        "lugar" : "Auditorio Gota de Plata",
        "url" : "http://dif.hidalgo.gob.mx/InformeActividades/2doInforme/",
        "anio" : "2024",
        "recursos" : [
           /* {
                "recurso" : "Galeria",
                "url" : "https://dif.hidalgo.gob.mx/InformeActividades/2doInforme/video_2doInforme.mp4"
            },*/
            {
                "recurso" : "Video",
                "url" : "https://dif.hidalgo.gob.mx/informes/2022-2028/2do_Informe_2024.mp4"
            }
        ]
    },
    {
        "imagen" : "http://dif.hidalgo.gob.mx/informes/2022-2028/3er_informe_2025.jpg",
        "informe" : "3er. Informe",
        "fecha" : "20 de Noviembre de 2025",
        "lugar" : "Sistema DIF Hidalgo",
        "url" : "https://dif.hidalgo.gob.mx/informes/2022-2028/3er_Informe_Edda_Vite.pdf",
        "anio" : "2025",
        "recursos" : [
           /* {
                "recurso" : "Galeria",
                "url" : "https://dif.hidalgo.gob.mx/InformeActividades/2doInforme/video_2doInforme.mp4"
            },*/
            {
                "recurso" : "Libro digital",
                "url" : "https://dif.hidalgo.gob.mx/informes/2022-2028/3er_Informe_Edda_Vite.pdf"
            }
        ]
    },
    {
        "imagen" : "http://dif.hidalgo.gob.mx/informes/2022-2028/4to_informe_2026.png",
        "informe" : "4to. Informe",
        "fecha" : "xx de Noviembre de 2026",
        "lugar" : "Sistema DIF Hidalgo",
        "url" : "https://dif.hidalgo.gob.mx/informes/2022-2028/3er_Informe_Edda_Vite.pdf",
        "anio" : "2026",
        "recursos" : [
           /* {
                "recurso" : "Galeria",
                "url" : "https://dif.hidalgo.gob.mx/InformeActividades/2doInforme/video_2doInforme.mp4"
            },*/
            {
                "recurso" : "Libro digital",
                "url" : "https://dif.hidalgo.gob.mx/informes/2022-2028/3er_Informe_Edda_Vite.pdf"
            }
        ]
    }

    
]